import PriorityTargetDto from "../../dto/PriorityTargetDto";

export default class UpdatePriorityTargetRequest {
  priorityTargets = [];
  termId;
  listId;
  constructor(input) {
    this.termId = input.termId;
    this.listId = input.listId;
    input.rows.forEach(data => {
      const prioritytarget = new PriorityTargetDto(data);
      this.priorityTargets.push(prioritytarget);
    });
  }
}